import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiCheck, FiX } = FiIcons;

const fits = [
  'Operations or IT managers at companies with 50–300 employees',
  'Asset-heavy industries: medical devices, equipment rental, field service, logistics',
  'Teams tracking assets and support tickets in spreadsheets and email today',
  'Companies that already use or are open to Jira / Atlassian tooling',
  'Organizations that want a working system in weeks, not months',
  'Teams that need ongoing admin support without hiring a full-time Atlassian admin',
];

const notFits = [
  'Companies without physical assets to track',
  'Teams wanting a customer-facing support portal (this is internal ops)',
  'Organizations not open to Jira Service Management as the platform',
  'Buyers looking for custom software development or ERP implementation',
  'Teams expecting unlimited scope or open-ended consulting',
];

const HomeBestFit = () => (
  <section className="py-24" style={{ background: '#ffffff' }}>
    <div className="max-w-5xl mx-auto px-8 lg:px-16">
      <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="mb-12">
        <p className="text-xs font-bold uppercase tracking-widest mb-4" style={{ color: '#16a34a' }}>Who This Is For</p>
        <h2 className="text-3xl md:text-4xl font-bold mb-4" style={{ color: '#052e16' }}>Built for a specific type of operation.</h2>
        <p className="text-sm max-w-xl leading-relaxed" style={{ color: '#166534' }}>
          This is not a generic IT consultancy. It is a focused JSM implementation for asset-heavy operations teams that have outgrown spreadsheets and need a real system — fast.
        </p>
      </motion.div>
      <div className="grid md:grid-cols-2 gap-6">
        <div className="p-7 rounded-xl border" style={{ background: '#f0fdf4', borderColor: '#bbf7d0' }}>
          <h3 className="text-sm font-bold mb-5 uppercase tracking-wider" style={{ color: '#16a34a' }}>Best fit</h3>
          <div className="space-y-4">
            {fits.map((item, i) => (
              <div key={i} className="flex items-start gap-3">
                <div className="w-5 h-5 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5" style={{ background: '#dcfce7' }}>
                  <SafeIcon icon={FiCheck} className="w-3 h-3" style={{ color: '#16a34a' }} />
                </div>
                <span className="text-sm leading-relaxed" style={{ color: '#166534' }}>{item}</span>
              </div>
            ))}
          </div>
        </div>
        <div className="p-7 rounded-xl border" style={{ background: '#f0fdf4', borderColor: '#bbf7d0' }}>
          <h3 className="text-sm font-bold mb-5 uppercase tracking-wider" style={{ color: '#6b7280' }}>Not a fit</h3>
          <div className="space-y-4">
            {notFits.map((item, i) => (
              <div key={i} className="flex items-start gap-3">
                <div className="w-5 h-5 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5" style={{ background: '#f3f4f6' }}>
                  <SafeIcon icon={FiX} className="w-3 h-3" style={{ color: '#9ca3af' }} />
                </div>
                <span className="text-sm leading-relaxed" style={{ color: '#6b7280' }}>{item}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default HomeBestFit;